import * as React from 'react'
import { Icon } from 'src/design-system/components/atoms/Icon'
import {
  CloseCircleOutline,
  CheckmarkCircle2Outline,
} from '@easy-eva-icons/react'
import styles from './Status.module.scss'

export type StatusProps = {
  status: 'meeting' | 'notMeeting'
}

export const Status: React.VFC<StatusProps> = ({ status }) => {
  const color = status === 'meeting' ? '#2e9e5d' : '#b21a1a'
  return (
    <span className={styles.statusContainer} style={{ color }}>
      <Icon size="sm" style={{ color }}>
        {status === 'meeting' && <CheckmarkCircle2Outline />}
        {status === 'notMeeting' && <CloseCircleOutline />}
      </Icon>
      {status === 'meeting' && 'Meeting'}
      {status === 'notMeeting' && 'Not meeting'}
    </span>
  )
}
